import Production from './production';

export default {
  ...Production,
  // After this point, you can override any setting from production or add a new one.
  cmsHost: 'https://cms-dev.enervee.com',
};
